import { Box, Button, Link, TextField, Typography } from "@mui/material";
import { useAsyncAction } from "nate-react-api-helpers";
import { useMemo, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { api } from "../../api/API";
import { AccountCard, emailInputProps } from "../account/AccountCard";

export function LoginPage() {
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const redirectTo = useMemo(() => {
        return new URLSearchParams(loc.search).get("r") || "/";
    }, [loc.search]);

    const login = useAsyncAction(async (input: { username: string; password: string }) => {
        await api.users.login(input);

        // full page load so every provider re-initializes against the new session
        window.location.href = redirectTo;
    }, [redirectTo]);

    return (
        <AccountCard title="TSK">
            <form onSubmit={e => {
                e.preventDefault();
                login.callback({ username: email, password: password });
            }}>
                {/* the email keyboard without the validation, since the field takes
                    whatever the account was set up under */}
                <TextField label="Email" autoComplete="username" fullWidth slotProps={emailInputProps}
                           value={email} onChange={e => setEmail(e.target.value)} />
                <div style={{ height: 8 }} />
                <TextField label="Password" type="password" autoComplete="current-password" fullWidth
                           value={password} onChange={e => setPassword(e.target.value)} />
                <div style={{ height: 16 }} />
                <Button type="submit" variant="contained" fullWidth disabled={login.loading}>Login</Button>
                {login.LoadingElement}

                {/* the server gives every failed login the same message, so the most
                    likely reason for a new account is named here */}
                {login.error && (
                    <Typography variant="caption" color="text.secondary" component="div" sx={{ pt: 1 }}>
                        Just registered? Open the link in the confirm email first.
                    </Typography>
                )}
            </form>

            <Box sx={{ display: "flex", justifyContent: "space-between", pt: 2 }}>
                <Link component={RouterLink} to="/forgot-password" variant="body2">Forgot password?</Link>
                <Link component={RouterLink} to="/register" variant="body2">Create an account</Link>
            </Box>
        </AccountCard>
    );
}
